ObjectUtils.extend(ErrorManager, {

  renderUserError: function renderUserError(message) {
    var overlayElement = DOM.findById('the_error_message');

    var messageContainer = DOM.findByClass(overlayElement, 'messageContainer');
    messageContainer.html(message);

    Overlay.present(overlayElement, {
      width: 400,
      clone: true
    });
  },

  renderSystemError: function renderSystemError(options) {
    Overlay.present('bug-report-form', {
      clone: true
    });
  },

  logErrorToServer: function logErrorToServer(data) {
    var requestUrl = data.requestUrl;
    var requestParams = data.requestParams;

    if (!requestUrl) {
      var windowUrl = Url.parse(window.location.href);
      data.requestUrl = windowUrl.path;
      data.requestParams = ObjectUtils.toString(windowUrl.queryParams);
    } else if (requestParams) {
      delete data.requestParams.__referer;
      delete data.requestParams.__mode;
      delete data.requestParams.__uid;
      delete data.requestParams.__codeVersion;
      data.requestParams = ObjectUtils.toString(data.requestParams);
    }

    ObjectUtils.extend(data, {
      __uid: Runtime.getUid(),
      __mode : 'async',
      __referer: AjaxManager.getReferer(),
      __codeVersion: Runtime.codeVersion,
      __authToken: Page.authToken,
    });
    Vendor.jQuery.ajax('/w/error/log', {
      data: Url.toQueryString(data),
      dataType: 'text'
    });
  }
});
